module.exports = __webpack_public_path__ + "media/notif4.72547c20.wav";